import { Component, OnInit, ViewContainerRef, ElementRef, ViewChild } from '@angular/core';
import { SampleAudit } from '../types';
import { SampleService } from '../services/sample.service'
import { Router, ActivatedRoute, Params } from '@angular/router';
//import { ToastrManager, Toastr } from 'ng6-toastr-notifications';
import 'rxjs/add/operator/switchMap';
import * as _ from 'underscore';
import { saveAs } from 'file-saver';

@Component({
  moduleId: module.id,
  templateUrl: '../../Templates/sample-audit.component.html'
})

export class SampleAuditComponent implements OnInit {
  sampleAudits: SampleAudit[]
  sampleNo: string
  fileToUpload: File = null;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sampleService: SampleService,
    //private toastr: ToastrManager,
    private vcr: ViewContainerRef) {
    //this.toastr.setRootViewContainerRef(vcr);
  }

  getSampleAudits(smpno: string): void {
    let hweRegex = new RegExp(/^\d{2}[HWE][MB]\d{7}$/)
    let lnwhRegex = new RegExp(/^\d{2}[AF]\d{7}\d?$/)
    switch (smpno.length) {
      case 10:
        let regex = new RegExp(/^\d{2}[A-Z0-9]\d{6}[0-9A-Z]$/)
        if (regex.test(smpno) && !lnwhRegex.test(smpno)) {  // contains F or A
          var sampno = smpno.substr(0, 9)
          this.sampleService.getSampleAudits(sampno)
            .subscribe(
              sampauds => this.sampleAudits = sampauds,
              err => console.log(err)
            )
        }
        else {
          this.sampleService.getSampleAudits(smpno)
            .subscribe(
              sampauds => this.sampleAudits = sampauds,
              err => console.log(err)
            )
        }
        break;
      case 11:
        if (lnwhRegex.test(smpno) || hweRegex.test(smpno)) {  // contains F or A
          var sampno = smpno.substr(0, 10)
          this.sampleService.getSampleAudits(sampno)
            .subscribe(
              sampauds => this.sampleAudits = sampauds,
              err => console.log(err)
            )
        }
        else {
          this.sampleService.getSampleAudits(smpno)
            .subscribe(
              sampauds => this.sampleAudits = sampauds,
              err => console.log(err)
            )
        }
        break;
      default:
        this.sampleService.getSampleAudits(smpno)
          .subscribe(
            sampauds => this.sampleAudits = sampauds,
            err => console.log(err)
          )
        break;
    }
  }

  private saveToFileSystem(response) {
    console.log(response);
    const contentDispositionHeader: string = response.headers.get('content-disposition');
    const parts: string[] = contentDispositionHeader.split(';');
    const filename = parts[1].split('=')[1];
    console.log(filename);
    const blob = new File([response._body], filename, { type: 'text/plain;charset=utf-8' });
    saveAs(blob);
  }

  uploadList(files: FileList) {
    this.fileToUpload = files.item(0);
    console.log(this.fileToUpload);
    this.sampleService.postFile(this.fileToUpload).subscribe(response => this.saveToFileSystem(response))
  }

  samples(s: SampleAudit): void { //only valid for 'current' samples, not archived in audit.
    if (s.BoxId > 0) {
      this.router.navigate(['/boxaudit', s.BoxId]); //SampleAudit type needs Box/Rack ids.
    }
    if (s.RackId > 0) {
      this.router.navigate(['/racksamples', s.RackId]); //SampleAudit type needs Box/Rack ids.
    }
    //this.toastr.info('not found','?');
  }

  ngOnInit(): void {
    this.route.params
      .subscribe((params: Params) => {
        this.sampleNo = params['id'];
        console.log(this.sampleNo)
        this.getSampleAudits(this.sampleNo)
      });
  }
}
